import styled from "styled-components";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";

export const StyledVerifiedShieldIcon = styled(VerifiedUserOutlinedIcon)`
    width: 45px;
    height: 20px;
    color: var(--color-success);
`;

export const StyledLabelFeature = styled.span`
    color: var(--color-grey-900);
    text-align: left;
    font-size: var(--size-16);
`;

export const StyledLabelInfoFeature = styled.span`
    flex: 1;
    font-size: var(--size-14);
    color: var(--color-grey-800);
    text-align: left;
`;

export const StyledValueInfoFeature = styled.span`
    flex: 1;
    font-size: var(--size-14);
    color: var(--color-grey-900);
    text-align: left;
`;
